import styled from "@emotion/styled";

import SelectList from "metabase/components/SelectList";
import { Icon } from "metabase/ui";

export const JoinStrategyIcon = styled(Icon)`
  color: var(--mb-color-brand);
`;

export const JoinStrategyList = styled(SelectList)`
  padding: 0.5rem;
`;
